import { type FC, type MouseEventHandler } from 'react';
import { Button } from '@mantine/core';
import { useConfirmPayinOrder } from '~/entities/payin';

interface ConfirmProps {
    id: string;
    disabled?: boolean;
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

export const Confirm: FC<ConfirmProps> = ({ id, disabled, onSuccess, onError }) => {
    const { mutate, isPending } = useConfirmPayinOrder({ onSuccess, onError });

    const handleConfirm: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        mutate({
            orderId: {
                value: id,
            },
        });
    };

    return (
        <Button
            title='Подтвердить получение'
            loading={isPending}
            onClick={handleConfirm}
            disabled={isPending || disabled}
        >
            Подтвердить получение
        </Button>
    );
};
